var _a;
import { ThemeBreakpoints } from '../breakpoints';
var modalContentSizes = (_a = {},
    _a[ThemeBreakpoints.MOBILE] = {
        maxHeight: '548px',
        width: '418px',
    },
    _a[ThemeBreakpoints.SMALL] = {
        maxHeight: '548px',
        width: '418px',
    },
    _a[ThemeBreakpoints.MEDIUM] = {
        maxHeight: '548px',
        width: '728px',
    },
    _a[ThemeBreakpoints.LARGE] = {
        maxHeight: '548px',
        width: '1098px',
    },
    _a);
export default modalContentSizes;
